{
  "app": { "name": "Atlas OMS" },
  "state": { "loading": "Loading", "error": "Something went wrong" },
  "action": {
    "save": "Save",
    "save_draft": "Save draft",
    "cancel": "Cancel",
    "delete": "Delete",
    "duplicate": "Duplicate",
    "export": "Export",
    "search": "Search",
    "clear": "Clear",
    "back": "Back",
    "continue": "Continue",
    "create": "Create",
    "edit": "Edit",
    "sign_in": "Sign in",
    "sign_out": "Sign out",
    "get_started": "Get started"
  },
  "empty": {
    "no_results": "No results match",
    "no_data": "No data yet",
    "clear_filters": "Clear filters"
  },
  "pagination": {
    "rows_per_page": "Rows per page",
    "page_of": "Page {{current}} of {{total}}",
    "sorted_by_newest": "Sorted by newest",
    "prev": "Previous",
    "next": "Next",
    "showing": "Showing {{from}}–{{to}} of {{total}}"
  },
  "user_menu": {
    "profile": "Profile",
    "language": "Language",
    "sign_out": "Sign out"
  },
  "loading": "Loading",
  "saving": "Saving",
  "placeholder": {
    "empty": "—"
  },
  "errors": {
    "unexpected": "Something went wrong. Please try again.",
    "network": "Network error. Check your connection.",
    "forbidden": "You don't have permission to do this.",
    "request_failed": "Request failed ({{status}})"
  },
  "actions": {
    "dismiss": "Dismiss"
  },
  "density": {
    "label": "Row density",
    "compact": "Compact",
    "default": "Default",
    "comfortable": "Comfortable"
  },
  "filters": {
    "active": "Active filters",
    "clear_all": "Clear all"
  },
  "language": { "label": "Language", "en": "EN", "th": "TH" }
}
